import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: 'autofocus'
})
export class AutoFocusDirective implements AfterViewInit {
  constructor(private elementRef: ElementRef) {
     // This is intentional
  }

  ngAfterViewInit() {
    this.elementRef.nativeElement.focus();
  }
}
